import { Page } from "components/common";
import { useState } from "react";
import { Trans } from "react-i18next";
import BackButton from "components/refactoring/BackButton"
import TrialBalance from "./TrialBalance";
import { TrialBalanceWithMovementOld } from "./TrialBalanceWithMovementOld";
import { TrialBalanceWithMovement } from "./TrialBalanceWithMovement";
import { TrialBalanceWithMovementBySummary } from "./TrialBalanceWithMovementBySummary";

const { Nav, TabContent, TabPane } = require("reactstrap");

export default function TrailBalanceWrapper(props) {
    const history = props?.history;
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const tab = params.get('tab')
    const [activeTab, setActiveTab] = useState(tab || "1");

    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            history.push({
                pathname: window.location.pathname,
                search: `?tab=${tab}`
              })
        }
    }

    return (
        <Page title="Trial Balance Reports" className="inv-tabs nw-list">
            <BackButton />
            <Nav tabs className="nw-tabs2 inv-tabs mb-3">
                <div onClick={() => toggleTab('1')} className={`btn ${activeTab == '1' ? `active-tab` : ''}`}>
                    <Trans>Trial Balance</Trans>
                </div>
                <div onClick={() => toggleTab('2')} className={`btn ${activeTab == '2' ? `active-tab` : ''}`}>
                    <Trans>Trial Balance With Movement</Trans>
                </div>
                <div onClick={() => toggleTab('3')} className={`btn ${activeTab == '3' ? `active-tab` : ''}`}>
                    <Trans>Trial Balance With Movement (Detail)</Trans>
                </div>
                <div onClick={() => toggleTab('4')} className={`btn ${activeTab == '4' ? `active-tab` : ''}`}>
                    <Trans>Trial Balance With Movement (Summary)</Trans>
                </div>
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                    <TrialBalance {...props} />
                </TabPane>
                <TabPane tabId="2">
                    {activeTab == '2' &&
                        <TrialBalanceWithMovementOld {...props} />
                    }
                </TabPane>
                <TabPane tabId="3">
                    {activeTab == '3' &&
                        <TrialBalanceWithMovement {...props} />
                    }
                </TabPane>
                <TabPane tabId="4">
                    {activeTab == '4' &&
                        <TrialBalanceWithMovementBySummary {...props} />
                    }
                </TabPane>
            </TabContent>
        </Page>
    )
}

